import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.pages.POILocation.title',
    defaultMessage: 'Location',
  },
  subtitle: {
    id: 'app.pages.POILocation.subtitle',
    defaultMessage: 'Please select the correct location that you are currently at.',
  },
  locationNotListed: {
    id: 'app.pages.POILocation.locationNotListed',
    defaultMessage: 'My location is not listed',
  },
  milestone_label: {
    id: 'app.pages.POILocation.milestone',
    defaultMessage: 'milestone',
  },
});
